"use client";

import React from "react";
import AppLayout from "@/components/shared/appLayout";
import Image from "next/image";
import { investmentServices } from "@/components/utils/data";

const InvestmentManagement = () => {
  return (
    <AppLayout>
      {/* Banner section  */}
      <div className="relative h-[80vh] sm:h-[35vh] w-full px-5 bg-[url('/investment-management/bg.jpeg')] bg-cover bg-center flex items-center justify-center text-white z-[-1]">
        <div className="absolute inset-0 bg-black bg-opacity-80"></div>

        <div className="relative z-10 m-auto max-w-7xl text-center">
          <h1 className="font-bold text-[35px] sm:text-[45px] leading-[2.2rem]">
            Investment Management
          </h1>
          <p className="text-[15px] sm:text-[17px] font-medium sm:font-normal mt-5">
            ACQ Investment Managers stands at the intersection of expertise and
            innovation. Our entrepreneurial mindset enables us to act decisively
            in an ever-changing market, while our disciplined approach ensures
            that every decision aligns with our clients&apos; goals. Guided by
            integrity, transparency, and a relentless pursuit of excellence, we
            are dedicated to building lasting partnerships and delivering
            results that consistently exceed expectations. Through our services,
            we empower clients to seize opportunities, mitigate risks, and
            create enduring value—today and in the future. At ACQ, your success
            is our mission.
          </p>
        </div>
      </div>

      {/* Our approach section  */}
      <div className="pt-[4rem] md:px-[3rem] xl:pt-[6rem] xl:px-[6rem] px-5">
        <h1 className="text-[32px] font-bold text-center">Our Approach</h1>
        <p className="text-[16px] lg:text-[17px] font-normal leading-[1.7rem] text-[#475467] text-center mt-2">
          At ACQ Investment Managers, we specialize in helping clients navigate
          the complexities of financial markets to achieve sustainable alpha. As
          a Nigeria SEC-registered Fund Portfolio Manager, we are committed to
          delivering superior investment outcomes through innovative strategies,
          deep market insights, and a client-centric approach. Our
          entrepreneurial spirit drives us to identify opportunities, adapt to
          market dynamics, and create value across diverse asset classes.
        </p>

        <div className="w-full max-h-[608px] mt-10">
          <Image
            src="/investment-management/approach1.svg"
            height={1000}
            width={1000}
            alt=""
            className="object-cover h-[40vh] sm:h-full w-full "
          />
        </div>
      </div>

      {/* Our services section  */}
      <div className="pt-[5rem] md:px-[3rem] xl:pt-[6rem] xl:px-[6rem] px-5">
        <h1 className="text-[32px] font-bold text-center">Our Services</h1>
        <div className="grid md:grid-cols-2 gap-8 mt-10 mt:mt-8">
          {investmentServices.map((service, index) => {
            const { img, title, description } = service;
            return (
              <div
                className="bg-[#F4F4F4] rounded-xl p-4 group block transition-all duration-300 transform hover:scale-[1.03]"
                key={index}
              >
                <div className="relative w-full h-[300px] rounded-xl overflow-hidden">
                  <Image
                    src={img}
                    height={800}
                    width={800}
                    alt={title}
                    className="object-cover h-full w-full rounded-xl transition-transform duration-300 group-hover:scale-105"
                    quality={50}
                    priority
                  />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                </div>

                <h1 className="text-[20px] font-[700] mt-3">{title}</h1>
                <p className="text-[15.5px] md:text-[16px] font-medium mt-2 text-[#475467] tracking-wide">
                  {description}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Our approach section  */}
      <div className="pt-[6rem] md:px-[3rem] xl:pt-[6rem] xl:px-[6rem] px-5">
        <h1 className="text-[32px] font-bold text-center">Our Promises</h1>
        <p className="text-[16px] lg:text-[17px] font-normal leading-[1.7rem] text-[#475467] text-center mt-2">
          Our team at ACQ Investment Managers have been investing in Africa and
          globally for over 20 years. We are committed to ensuring our investors
          gain alpha while actively managing the unique risks inherent in
          investing in Emerging Markets. We will guide you through the process
          of setting your investment objectives, allocating capital, choosing
          the right asset classes for your unique situation, and selecting the
          best run companies and assets.
        </p>
      </div>

      <div className="bg-primaryColor text-center py-2 text-[14px] text-white font-medium italic mt-6">
        At ACQ Investment Managers, we help you to ACQuire Alpha, and to do so
        for a very long time!
      </div>
    </AppLayout>
  );
};

export default InvestmentManagement;
